import { ConfigSettingsService } from '../config-settings/config-settings.service';
import { PinInSessionService } from '../../services/pin-in-session.service';
import { PinPersistentService } from '../../services/pin-persistent.service';

export abstract class SavePinBase {
  public abstract setPin(username: string, pin: string): Promise<void>;
  public abstract getPin(username?: string): Promise<string | null>;
  public abstract resetPin(username?: string): Promise<void>;
}

export const savePinServiceFactory = (
  configSettingsService: ConfigSettingsService,
  pinInSessionService: PinInSessionService,
  pinPersistentService: PinPersistentService,
): SavePinBase => {
  return configSettingsService.appSettings.pinConfiguration?.storage === 'session'
    ? pinInSessionService
    : pinPersistentService;
};
